import { render, staticRenderFns } from "./TReportsPages.vue?vue&type=template&id=e864618c&"
import script from "./TReportsPages.vue?vue&type=script&lang=js&"
export * from "./TReportsPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports